var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBetterThanReviewSites(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 202.49 144.63",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient-16);stroke:url(#linear-gradient-17);}.cls-1,.cls-2,.cls-3,.cls-4,.cls-5,.cls-6,.cls-7,.cls-8,.cls-9,.cls-10,.cls-11,.cls-12,.cls-13,.cls-14,.cls-15,.cls-16,.cls-17,.cls-18{stroke-miterlimit:10;}.cls-1,.cls-2,.cls-4,.cls-5,.cls-6,.cls-7,.cls-8,.cls-9,.cls-19,.cls-10,.cls-11,.cls-12,.cls-13,.cls-14,.cls-15,.cls-16,.cls-17,.cls-18{stroke-width:2px;}.cls-20{fill:#0bf415;}.cls-2{fill:url(#linear-gradient-25);stroke:url(#linear-gradient-26);}.cls-2,.cls-6,.cls-18{fill-opacity:.5;}.cls-21{fill:url(#linear-gradient-22);}.cls-21,.cls-22,.cls-23,.cls-24,.cls-19,.cls-25,.cls-26,.cls-27,.cls-28,.cls-29,.cls-30,.cls-31,.cls-32{stroke-linecap:round;stroke-linejoin:round;}.cls-21,.cls-22,.cls-23,.cls-24,.cls-25,.cls-26,.cls-27,.cls-28,.cls-29,.cls-30,.cls-31,.cls-32{stroke:#fff;}.cls-3{fill:url(#linear-gradient-28);stroke:url(#linear-gradient-29);stroke-width:5px;}.cls-4{stroke:url(#linear-gradient-18);}.cls-4,.cls-5,.cls-8,.cls-9,.cls-11,.cls-14,.cls-15,.cls-16,.cls-17{fill:#fff;}.cls-5{stroke:url(#linear-gradient-7);}.cls-22{fill:url(#linear-gradient-33);}.cls-6{fill:url(#linear-gradient-13);stroke:url(#linear-gradient-14);}.cls-23{fill:url(#linear-gradient-35);}.cls-7{stroke:url(#linear-gradient-3);}.cls-7,.cls-12,.cls-13{fill:none;}.cls-33{fill:#020004;isolation:isolate;opacity:.18;}.cls-8{stroke:url(#linear-gradient-30);}.cls-24{fill:url(#linear-gradient-24);}.cls-9{stroke:url(#linear-gradient-8);}.cls-19{fill:rgba(255,255,255,.75);stroke:#7da2fe;}.cls-10{fill:url(#linear-gradient-4);stroke:url(#linear-gradient-5);}.cls-11{stroke:url(#linear-gradient-31);}.cls-12{stroke:url(#linear-gradient-27);}.cls-13{stroke:url(#linear-gradient-15);}.cls-14{stroke:url(#linear-gradient-19);}.cls-25{fill:url(#linear-gradient-36);}.cls-26{fill:url(#linear-gradient-23);}.cls-15{stroke:url(#linear-gradient-6);}.cls-16{stroke:url(#linear-gradient-32);}.cls-27{fill:url(#linear-gradient-9);}.cls-28{fill:url(#linear-gradient-34);}.cls-29{fill:url(#linear-gradient-12);}.cls-17{stroke:url(#linear-gradient-20);}.cls-30{fill:url(#linear-gradient-10);}.cls-18{fill:url(#linear-gradient);stroke:url(#linear-gradient-2);}.cls-31{fill:url(#linear-gradient-11);}.cls-32{fill:url(#linear-gradient-21);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -258.56,
    y1: 1526.33,
    x2: -251.03,
    y2: 1526.33,
    gradientTransform: "translate(287 1593.42) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#386aff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1b86f6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -259.56,
    x2: -250.03,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -255.78,
    y1: 1530.39,
    x2: -253.78,
    y2: 1530.39,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: -285.27,
    y1: 1503.68,
    x2: -224.31,
    y2: 1503.68,
    gradientTransform: "translate(287 1593.42) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9bb5ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8fc3fa"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: -286.27,
    y1: 1503.68,
    x2: -223.31,
    y2: 1503.68,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: -273.09,
    y1: 1508.95,
    x2: -261.56,
    y2: 1508.95,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: -248,
    y1: 1508.95,
    x2: -236.47,
    y2: 1508.95,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: -273.09,
    y1: 1495.54,
    x2: -236.48,
    y2: 1495.54,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: -8595.38,
    y1: 1553.9,
    x2: -8584.99,
    y2: 1553.9,
    gradientTransform: "translate(-8539.24 1593.42) rotate(-180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: -8582.89,
    y1: 1553.9,
    x2: -8572.51,
    y2: 1553.9,
    gradientTransform: "translate(-8539.24 1593.42) rotate(-180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: -8570.4,
    y1: 1553.9,
    x2: -8560.01,
    y2: 1553.9,
    gradientTransform: "translate(-8539.24 1593.42) rotate(-180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: -8557.91,
    y1: 1553.9,
    x2: -8547.53,
    y2: 1553.9,
    gradientTransform: "translate(-8539.24 1593.42) rotate(-180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: -1580.31,
    x2: -1572.77,
    gradientTransform: "translate(-1406.26 1593.42) rotate(-180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: -1581.31,
    x2: -1571.77,
    gradientTransform: "translate(-1406.26 1593.42) rotate(-180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: -1577.54,
    y1: 1530.39,
    x2: -1575.54,
    y2: 1530.39,
    gradientTransform: "translate(-1406.26 1593.42) rotate(-180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: -147.21,
    x2: -86.24,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: -148.21,
    y1: 1503.68,
    x2: -85.24,
    y2: 1503.68,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: -1594.85,
    y1: 1508.95,
    x2: -1583.32,
    y2: 1508.95,
    gradientTransform: "translate(-1406.26 1593.42) rotate(-180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: -1569.76,
    y1: 1508.95,
    x2: -1558.23,
    y2: 1508.95,
    gradientTransform: "translate(-1406.26 1593.42) rotate(-180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: -1594.85,
    y1: 1495.53,
    x2: -1558.24,
    y2: 1495.53,
    gradientTransform: "translate(-1406.26 1593.42) rotate(-180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    x1: -7273.62,
    y1: 1553.9,
    x2: -7263.24,
    y2: 1553.9,
    gradientTransform: "translate(7419.98 1593.42) scale(1 -1)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-22",
    x1: -7261.14,
    y1: 1553.9,
    x2: -7250.75,
    y2: 1553.9,
    gradientTransform: "translate(7419.98 1593.42) scale(1 -1)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-23",
    x1: -7248.64,
    y1: 1553.9,
    x2: -7238.26,
    y2: 1553.9,
    gradientTransform: "translate(7419.98 1593.42) scale(1 -1)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-24",
    x1: -7236.16,
    y1: 1553.9,
    x2: -7225.77,
    y2: 1553.9,
    gradientTransform: "translate(7419.98 1593.42) scale(1 -1)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-25",
    x1: -193.19,
    y1: 1527.36,
    x2: -179.98,
    y2: 1527.36,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-26",
    x1: -194.19,
    y1: 1527.36,
    x2: -178.98,
    y2: 1527.36,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-27",
    x1: -187.58,
    y1: 1534.5,
    x2: -185.58,
    y2: 1534.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-28",
    x1: -240.02,
    y1: 1487.67,
    x2: -133.15,
    y2: 1487.67,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-29",
    x1: -242.52,
    y1: 1487.67,
    x2: -130.65,
    y2: 1487.67,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-30",
    x1: -217.92,
    y1: 1496.91,
    x2: -199.22,
    y2: 1496.91,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-31",
    x1: -173.94,
    y1: 1496.91,
    x2: -155.24,
    y2: 1496.91,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-32",
    x1: -217.92,
    y1: 1473.39,
    x2: -155.24,
    y2: 1473.39,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-33",
    x1: -8681.61,
    y1: 1571.21,
    x2: -8663.4,
    y2: 1571.21,
    gradientTransform: "translate(-8539.24 1593.42) rotate(-180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-34",
    x1: -8659.71,
    y1: 1571.21,
    x2: -8641.51,
    y2: 1571.21,
    gradientTransform: "translate(-8539.24 1593.42) rotate(-180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-35",
    x1: -8637.82,
    y1: 1571.21,
    x2: -8619.61,
    y2: 1571.21,
    gradientTransform: "translate(-8539.24 1593.42) rotate(-180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-36",
    x1: -8615.92,
    y1: 1571.21,
    x2: -8597.72,
    y2: 1571.21,
    gradientTransform: "translate(-8539.24 1593.42) rotate(-180)",
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M35.97,68.97h-7.53c0-1.89,1.42-3.47,3.25-3.73,.17-.03,.34-.03,.51-.03s.35,0,.51,.03c1.82,.26,3.25,1.84,3.25,3.73Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 32.22,
    y1: 65.08,
    x2: 32.22,
    y2: 60.96
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-20",
    cx: 32.22,
    cy: 58.64,
    r: 2.33
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M62.69,79.25v20.97c0,4.83-3.37,8.9-7.88,9.99-.77,.19-1.57,.28-2.39,.28H12c-5.65,0-10.27-4.62-10.27-10.27v-20.97c0-5.65,4.62-10.27,10.27-10.27H52.69c2.37,.05,4.54,.92,6.26,2.34,2.28,1.88,3.74,4.74,3.74,7.92h0Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-15",
    cx: 19.67,
    cy: 84.46,
    r: 4.77
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 44.76,
    cy: 84.46,
    r: 4.77
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M14.91,93.04H49.52v.96c0,4.82-3.91,8.73-8.73,8.73H23.63c-4.82,0-8.73-3.91-8.73-8.73v-.96h0Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M67.87,38.8v10.41c0,3.73-3.05,6.79-6.79,6.79h-4.92l-5.82,5.85v-5.85H12.75c-3.73,0-6.79-3.05-6.79-6.79v-10.41c0-3.73,3.06-6.79,6.79-6.79H61.08c3.73,0,6.79,3.05,6.79,6.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M63.43,34.27v10.5c0,3.77-3.08,6.85-6.85,6.85h-4.95l-5.86,5.9v-5.9H7.85c-3.77,0-6.85-3.08-6.85-6.85v-10.5c0-3.77,3.08-6.85,6.85-6.85H56.58c3.77,0,6.85,3.08,6.85,6.85Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-27",
    points: "50.95 34.58 49.35 37.83 45.76 38.35 48.36 40.88 47.74 44.45 50.95 42.77 54.16 44.45 53.54 40.88 56.14 38.35 52.56 37.83 50.95 34.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-30",
    points: "38.46 34.58 36.86 37.83 33.27 38.35 35.86 40.88 35.26 44.45 38.46 42.77 41.66 44.45 41.06 40.88 43.65 38.35 40.06 37.83 38.46 34.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "25.97 34.58 24.36 37.83 20.78 38.35 23.38 40.88 22.76 44.45 25.97 42.77 29.18 44.45 28.56 40.88 31.16 38.35 27.57 37.83 25.97 34.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "13.48 34.58 11.88 37.83 8.29 38.35 10.88 40.88 10.27 44.45 13.48 42.77 16.69 44.45 16.08 40.88 18.67 38.35 15.09 37.83 13.48 34.58"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M166.52,68.97h7.53c0-1.89-1.42-3.47-3.25-3.73-.17-.03-.34-.03-.51-.03s-.35,0-.51,.03c-1.82,.26-3.25,1.84-3.25,3.73h0Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 170.28,
    y1: 65.08,
    x2: 170.28,
    y2: 60.96
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-20",
    cx: 170.28,
    cy: 58.64,
    r: 2.33
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M200.76,79.25v20.97c0,5.65-4.62,10.27-10.27,10.27h-40.43c-1.34,0-2.62-.26-3.8-.74-3.78-1.51-6.47-5.23-6.47-9.53v-20.97c0-2.85,1.18-5.44,3.07-7.31,1.51-1.48,3.45-2.5,5.62-2.84,.51-.08,1.04-.12,1.57-.12h40.43c5.65,0,10.27,4.62,10.27,10.27Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 182.83,
    cy: 84.46,
    r: 4.77
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-14",
    cx: 157.74,
    cy: 84.46,
    r: 4.77
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M178.87,102.73h-17.16c-4.82,0-8.73-3.91-8.73-8.73v-.96h34.61v.96c0,4.82-3.91,8.73-8.73,8.73Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M134.62,38.8v10.41c0,3.73,3.06,6.79,6.79,6.79h4.92l5.82,5.85v-5.85h37.6c3.73,0,6.79-3.05,6.79-6.79v-10.41c0-3.73-3.06-6.79-6.79-6.79h-48.33c-3.73,0-6.79,3.05-6.79,6.79h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M139.07,34.27v10.5c0,3.77,3.08,6.85,6.85,6.85h4.95l5.86,5.9v-5.9h37.91c3.77,0,6.85-3.08,6.85-6.85v-10.5c0-3.77-3.08-6.85-6.85-6.85h-48.73c-3.77,0-6.85,3.08-6.85,6.85h0Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-32",
    points: "151.54 34.58 153.15 37.83 156.74 38.35 154.14 40.88 154.75 44.45 151.54 42.77 148.33 44.45 148.95 40.88 146.36 38.35 149.94 37.83 151.54 34.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-21",
    points: "164.04 34.58 165.64 37.83 169.23 38.35 166.63 40.88 167.25 44.45 164.04 42.77 160.83 44.45 161.44 40.88 158.84 38.35 162.43 37.83 164.04 34.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-26",
    points: "176.52 34.58 178.13 37.83 181.72 38.35 179.12 40.88 179.73 44.45 176.52 42.77 173.31 44.45 173.93 40.88 171.34 38.35 174.92 37.83 176.52 34.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-24",
    points: "189.02 34.58 190.62 37.83 194.21 38.35 191.61 40.88 192.22 44.45 189.02 42.77 185.81 44.45 186.42 40.88 183.82 38.35 187.41 37.83 189.02 34.58"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M159.23,76.79v40.7h-.94c-1.57,0-3.06-.3-4.44-.86v13.5c0,6.6-5.4,12-12,12H58.98c-6.6,0-12-5.4-12-12v-12.97c-.9,.22-1.83,.33-2.79,.33h-2.59v-40.7c0-2.97,1.09-5.7,2.9-7.8,2.77,.06,5.31,1.08,7.32,2.74,2-1.49,4.48-2.38,7.16-2.38h34.83c0-1.76,.71-3.38,1.85-4.56h9.51c1.14,1.18,1.85,2.8,1.85,4.56h34.83c3.08,0,5.9,1.18,8.03,3.09,1.76-1.73,4.03-2.92,6.57-3.32,1.73,2.09,2.78,4.76,2.78,7.67Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M107.02,69.36h-13.21c0-1.76,.71-3.38,1.85-4.56,1.01-1.06,2.35-1.77,3.85-1.98,.29-.04,.6-.06,.9-.06s.61,.02,.91,.06c1.5,.21,2.85,.92,3.85,1.98,1.14,1.18,1.85,2.8,1.85,4.56Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-12",
    x1: 100.42,
    y1: 62.53,
    x2: 100.42,
    y2: 55.31
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-20",
    cx: 100.42,
    cy: 51.24,
    r: 4.08
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M153.85,81.36v48.78c0,6.6-5.4,12-12,12H58.98c-6.6,0-12-5.4-12-12v-48.78c0-3.92,1.91-7.42,4.84-9.62,2-1.49,4.48-2.38,7.16-2.38h82.87c3.08,0,5.9,1.18,8.03,3.09,2.43,2.21,3.97,5.39,3.97,8.91Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-8",
    cx: 78.43,
    cy: 96.5,
    r: 8.35
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-11",
    cx: 122.41,
    cy: 96.5,
    r: 8.35
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M70.08,111.54h60.68c0,9.37-7.61,16.98-16.98,16.98h-26.72c-9.37,0-16.98-7.61-16.98-16.98h0Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M162.92,20.96v18.26c0,6.55-5.36,11.9-11.9,11.9h-8.62l-10.2,10.26v-10.26H66.29c-6.55,0-11.9-5.36-11.9-11.9V20.96c0-6.55,5.36-11.9,11.9-11.9h84.73c6.55,0,11.9,5.36,11.9,11.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M155.13,13V31.41c0,6.6-5.4,12-12,12h-8.69l-10.28,10.35v-10.35H57.7c-6.6,0-12-5.4-12-12V13c0-6.6,5.4-12,12-12h85.43c6.6,0,12,5.4,12,12Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "133.27 13.55 130.45 19.24 124.16 20.16 128.71 24.59 127.64 30.86 133.27 27.9 138.89 30.86 137.82 24.59 142.37 20.16 136.08 19.24 133.27 13.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-28",
    points: "111.37 13.55 108.56 19.24 102.27 20.16 106.82 24.59 105.75 30.86 111.37 27.9 116.99 30.86 115.92 24.59 120.47 20.16 114.18 19.24 111.37 13.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-23",
    points: "89.48 13.55 86.66 19.24 80.37 20.16 84.92 24.59 83.85 30.86 89.48 27.9 95.1 30.86 94.03 24.59 98.58 20.16 92.29 19.24 89.48 13.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "67.58 13.55 64.77 19.24 58.48 20.16 63.03 24.59 61.96 30.86 67.58 27.9 73.2 30.86 72.13 24.59 76.68 20.16 70.39 19.24 67.58 13.55"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBetterThanReviewSites);
export default __webpack_public_path__ + "static/media/betterThanReviewSites.fc2472daf5bce02c2f8c1fa312e4d196.svg";
export { ForwardRef as ReactComponent };